import BackButton from './back_button'

export default class SubmenuMobile {
  constructor(elSubmenu){
    this.submenu = elSubmenu
    this.parentSubmenu = this.submenu.parent()

    this.display()
  }

  display(){
    this.submenu.addClass('mhg-submenu-active').removeClass('sf-expanded')
    this.parentSubmenu.addClass('mhg-expanded-submenu')
    jQuery('.mhg_mainnav').addClass('mhg-submenu-open')

    this.createBackButton()
  }

  createBackButton(){
    const callback = () => {
      this.reset()
    }

    this.backButton = new BackButton(this.parentSubmenu.parent(), callback)
  }

  reset(){
    jQuery('.mhg_mainnav').removeClass('mhg-submenu-open')
    this.parentSubmenu.removeClass('mhg-expanded-submenu')
    this.submenu.removeClass('mhg-submenu-active')
  }

  destroy(){
    this.reset()

    if(this.backButton)
      this.backButton.destroy()
  }
}



// WEBPACK FOOTER //
// ./src/custom_menu/submenu_mobile.js